'use strict';
const allowedTypes = require('./allowed-image-types');
module.exports = function GoldImagePicker(filePicker, pageState, resourceManager) {
	if (!filePicker || !pageState || !resourceManager) {
		throw 'invalid-args';
	}
	const processImageResult = (result) => {
			if (allowedTypes.indexOf(result.type) > -1) {

				return {url: result.contents};
			} else {
				throw 'image-error';
			}
		},
		pickImage = async (userProfile, options) => {
			const result = await filePicker.pickFile('.jpg,.jpeg,.png,.gif,' + allowedTypes.join(','));
			try {
				const imageResource = processImageResult(result),
					dimensions = await resourceManager.calculateImageDimensions(imageResource.url),
					shouldUploadAssets = pageState.getAllowedActions().uploadChanges,
					mergedResource = Object.assign({}, dimensions, imageResource);

				if (shouldUploadAssets) {
					if (options && options.notify) {
						options.notify('uploading', mergedResource.url);
					}
					const resourceId = await resourceManager.addGoldAsset(mergedResource.url);
					Object.assign(mergedResource, {url: resourceId});
				}
				return mergedResource;
			} catch(e) {
				throw 'image-error';
			}

		};

	/*
	const pickImage = function (userProfile, options) {
		return filePicker.pickFile('.jpg,.jpeg,.png,.gif,' + allowedTypes.join(',')).then((result) => {
			if (allowedTypes.indexOf(result.type) > -1) {
				resourceManager.calculateImageDimensions
				return {url: result.contents};
			} else {
				throw 'image-error';
			}
		}).then(imageResource => {
			const shouldUploadAssets = pageState.getAllowedActions().uploadChanges;
			if (!shouldUploadAssets) {
				return imageResource;
			}
			if (options && options.notify) {
				options.notify('uploading', imageResource.url);
			}
			return resourceManager.addGoldAsset(imageResource.url).then((resourceId) => {

				return {url: resourceId};
			})
			.catch(() => {
				throw 'image-error';
			});
		});
	};

	*/
	Object.freeze(Object.assign(this, {pickImage}));
};


